$(window).load(function(){
	if (!$('.ncp-2020--winners').length && !$('.ncp-2020--coduri').length ) {
		new TimelineMax({delay: 0.5})
			.staggerFromTo(".ncp-2020-sect1 h1, .ncp-2020-sect1 .f18, .ncp-2020-sect1-buttons, .ncp-2020-sect1-files, .ncp-2020-form-logged", 0.5,{ opacity:0, y:'20px', ease: Power2.easeOut},{ opacity:1, y:'0px'},0.15);
		new TimelineMax({delay: 0.5})
			.staggerFromTo(".sect1-beer, .sect1-premii, .stamp-no-alcohol, .stamp-18", 0.5,{ opacity:0, x:'20px', ease: Power2.easeOut},{ opacity:1, x:'0px'},0.15);
	}
});

$(document).ready(function() {

    $(".inpage").on('click', function(event) {
        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
          event.preventDefault();
          scrollToSection(this.hash,(window.matchMedia("(max-width: 767px)").matches ? 60 : 0));
        }
      });

    $('#ncp-2020-simpleform').on('click', function(){
        $('.ncp-2020-sect1-intro, .ncp-2020-sect1-buttons').slideUp();
        $('.ncp-2020-form-notlogged').slideDown();
		$('.ncp-2020').addClass('ncp-2020--logged');
    });

	// te-racoresti-si-castigi
	$("form.ncp-2020_register").on('submit', function(e){
		e.preventDefault();
		if($(this).data('submitting'))
			return false; //double submit

		$('.form-group', this).removeClass('has-error');
		$('.form-group span.help-block', this).remove();
		$(this).data('submitting', true).addClass('submitting');
		$('button[type=submit]', this).button('loading');
		// $('button[type=submit] span.submit-label', this).text('Se trimite...');

		$.ajax({
			type: $(this).attr('method'),
			url: $(this).attr('action'),
			data: $(this).serialize(),
			context: this,
	//			dataType: 'json',
			success: function(data){
				$('input[name=code]', this).val('');
				$('.ncp-2020--logged .ncp-2020-sect1-intro, .ncp-2020-form').addClass('disabled');
				$('.ncp-2020-form-confirmation h2').text('Codul a fost înscris!');
				$('.ncp-2020-form-confirmation p.message').html(data.success);
				$('#btn-confirmation').html('Înscrie un cod nou');
				$('.ncp-2020-form-confirmation').fadeIn();
				if (window.ga) {
					ga('send', 'pageview', '/cu-premii-tari/confirmare');
				}

				 window.dataLayer = window.dataLayer || [];
				 window.dataLayer.push({
				 'event': 'NCP2020Success'
				 });

			},
			error: function(xhr) {
				$('button[type=submit] span.submit-label', this).text('Trimite');
				if(xhr.status == 422) {
					$errors = "";
					for(var field in xhr.responseJSON) {
						if ( field != 'error_name' ) {
							for(var err in xhr.responseJSON[field])
								$errors += '<span class="help-block">'+xhr.responseJSON[field][err]+'</span>';
						}
					}
					if ( !!xhr.responseJSON['error_name'] ) {
						$('.ncp-2020-form-confirmation h2').text(xhr.responseJSON['error_name']);
					} else {
						$('.ncp-2020-form-confirmation h2').text('Te rugăm să completezi toate câmpurile.');
					}
					$('.ncp-2020-form-confirmation p.message').html($errors);
					$('#btn-confirmation').html('Mai încearcă o dată');
                    $('.ncp-2020--logged .ncp-2020-sect1-intro, .ncp-2020-form').addClass('disabled');
                    $('.ncp-2020-form-confirmation').fadeIn();
				} else if(xhr.status == 403) {
					console.log(xhr);
				}
			},
			complete: function(xhr) {
				$(this).data('submitting', false).removeClass('submitting');
				$('button[type=submit]',this).button('reset');
			}
		});
	});

	$('.ncp-2020-form-confirmation').on('click', 'a', function(e){
		$(e.delegateTarget).fadeOut(function () {
			$('.ncp-2020--logged .ncp-2020-sect1-intro, .ncp-2020-form').removeClass('disabled');
		});
	});

    var winnersList = new List('winners-list', {
      valueNames: ['name','city', 'date'],
      page: 24,
      pagination: true
    });

	var coduriList = new List('coduri-list', {
      valueNames: ['code','date'],
      page: 10,
      pagination: true
    });

	$('.winners-list-title-holder').click(function(){
		$('.search-holder input').val('');
		winnersList.search();
	});

	if (!$('.ncp-2020--winners').length && !$('.ncp-2020--coduri').length ) {

		//scroll animations
		var controller = new ScrollMagic.Controller();

		var scene = new ScrollMagic.Scene({
				triggerElement: ".ncp-2020-sect2", duration: 0, offset: 0, reverse: false
			})
			.setTween(
				new TimelineMax()
				.staggerFromTo(".ncp-2020-sect2 h2, .ncp-2020-sect2 p, .sect2-image", 0.5,{ opacity:0, y:'20px', ease: Power2.easeOut},{ opacity:1, y:'0px'},0.15)
			)
			.addTo(controller);


		var scene = new ScrollMagic.Scene({
				triggerElement: ".ncp-2020-sect3", duration: 0, offset: 0, reverse: false
			})
			.setTween(
				new TimelineMax()
				.staggerFromTo(".ncp-2020-sect3 h2, .ncp-2020-sect3 p, .ncp-2020-stores", 0.5,{ opacity:0, y:'20px', ease: Power2.easeOut},{ opacity:1, y:'0px'},0.15)
			)
			.addTo(controller);
	}
});
